import { Key, LineChart, Sparkles, MessageCircle, Camera, ShieldCheck } from "lucide-react";

const services = [
  {
    icon: Key,
    title: "Co-Hosting & Onboarding",
    desc: "We onboard your property with a design-forward approach and manage every guest touchpoint from arrival to departure.",
  },
  {
    icon: LineChart,
    title: "Dynamic Pricing",
    desc: "Data-driven rate optimization across Airbnb, VRBO, and Booking.com to maximize occupancy and nightly revenue.",
  },
  {
    icon: Sparkles,
    title: "Housekeeping & Turnovers",
    desc: "Hotel-grade cleaning between stays with linen program, restocking, and consistent QA inspections.",
  },
  {
    icon: MessageCircle,
    title: "24/7 Guest Support",
    desc: "Warm, responsive concierge care around the clock — resolving requests before they become issues.",
  },
  {
    icon: Camera,
    title: "Listing & Photography",
    desc: "Editorial photography, copywriting, and multi-platform listing management to make your property irresistible.",
  },
  {
    icon: ShieldCheck,
    title: "Maintenance & Trust",
    desc: "Preventive maintenance, vendor coordination, and vetted guest screening to protect your asset.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-parchment py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-3xl mb-20">
          <div className="text-xs tracking-[0.3em] uppercase text-brass mb-6">Services</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-espresso font-light">
            A complete management practice, <em className="not-italic text-brass">without compromise.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
          {services.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-card-${i}`}
              className="group"
            >
              <div className="border-t border-espresso/20 pt-8 group-hover:border-brass transition-colors duration-500">
                <s.icon strokeWidth={1.25} size={32} className="text-espresso group-hover:text-brass transition-colors duration-500" />
                <h3 className="font-serif text-2xl lg:text-3xl text-espresso mt-6">{s.title}</h3>
                <p className="mt-4 text-espresso/70 text-base leading-relaxed">{s.desc}</p>
                <div className="mt-6 text-[10px] tracking-[0.3em] uppercase text-taupe">
                  {String(i + 1).padStart(2, "0")} / {String(services.length).padStart(2, "0")}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
